/**
 * @file Faq.tsx
 * @description Faq page with conditional rendering based on user's premium status.
 */

import React, { useEffect } from "react";
import { useUserDetails } from "../../context/UserDetailsContext";
import { useHostElements } from "../../context/HostElementsContext";
import AlphabetBackground from "../../components/common/AlphabetBackground";
import PremiumFaqContent from "../../components/support/PremiumFaqContent";
import FreeFaqContent from "../../components/support/FreeFaqContent";

const Faq: React.FC = () => {
  const { userDetails } = useUserDetails();
  const { setPageBackground } = useHostElements();

  useEffect(() => {
    if (userDetails?.isPremium) {
      setPageBackground(
        "linear-gradient(360deg, #1E88E5 46.45%, #37D399 96.25%)"
      );
    } else {
      setPageBackground(null);
    }

    return () => setPageBackground(null);
  }, [userDetails?.isPremium, setPageBackground]);

  const alphabetBackgroundFill = userDetails?.isPremium ? "#ffffff" : "#e7dddc";
  const alphabetBackgroundOpacity = userDetails?.isPremium ? 0.1 : 0.5;

  return (
    <section className="mx-auto text-center max-w-content">
      <AlphabetBackground
        fill={alphabetBackgroundFill}
        opacity={alphabetBackgroundOpacity}
      />
      <h2
        className={`text-2xl !font-medium text-center !mb-20 relative ${
          userDetails?.isPremium ? "text-accent-content" : "text-primary"
        }`}
      >
        Benvenuto nel {userDetails?.isPremium ? "Premium" : "Free"} Plan!
      </h2>
      {userDetails?.isPremium ? <PremiumFaqContent /> : <FreeFaqContent />}
    </section>
  );
};

export default Faq;
